var map = {
	"./de/group-logo.png": "3JBw",
	"./en/group-logo.png": "R2jP",
	"./es/group-logo.png": "VGEu",
	"./fr/group-logo.png": "Cd55",
	"./ja/group-logo.png": "VJiU",
	"./ko/group-logo.png": "m7qc",
	"./pt/group-logo.png": "MgZt",
	"./ru/group-logo.png": "NJo5",
	"./tc/group-logo.png": "w7Lu",
	"./th/group-logo.png": "TG6c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "/75v";